
module.exports = {
  name: 'bounceInDown',
  option: {
    duration: '1s',
    mode: 'both'
  },
  timeline: {
    'from, 60%, 75%, 90%, to': {
      'animation-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)'
    },
    '0%': {
      opacity: '0',
      transform: 'translate3d(0, -3000px, 0)'
    },
    '60%': {
      opacity: '1',
      transform: 'translate3d(0, 25px, 0)'
    },
    '75%': {
      transform: 'translate3d(0, -10px, 0)'
    },
    '90%': {
      transform: 'translate3d(0, 5px, 0)'
    },
    to: {
      transform: 'none'
    }
  }
};



// WEBPACK FOOTER //
// ./lib/ctr-nodes/preset/animation/animate.css/bounceInDown.js